import api from './api';

const store = user => api.post(`/users`, user);

export default { store };
